// src/components/calculators/SocialSecuritySection.js
import React from 'react';
import { useCalculations } from '../../context/CalculationContext';
import SectionHeader from '../common/SectionHeader';
import SectionNavigation from '../common/SectionNavigation';
import SocialSecurityCalculator from './SocialSecurityCalculator';

function SocialSecuritySection({ onNextSection, onPreviousSection, currentSectionIndex, sectionNames, isEmbedded = false }) {
  const { handleSocialSecurityCalculation } = useCalculations();
  const currentYear = new Date().getFullYear();

  return (
    <div className="calculator-section">
      {!isEmbedded && (
        <SectionHeader title="Social Security Benefits" sectionKey="socialSecurityBenefits" />
      )}
      
      <div className="calculator-form">
          <SocialSecurityCalculator
            onCalculate={handleSocialSecurityCalculation}
            startYear={currentYear}
          />
        </div>
      {!isEmbedded && (
        <SectionNavigation
          onNextSection={onNextSection}
          onPreviousSection={onPreviousSection}
          currentSectionIndex={currentSectionIndex}
          sectionNames={sectionNames}
        />
      )}
    </div>
  );
}

export default SocialSecuritySection;
